import { useOutletContext } from "react-router-dom";
import { TemporarySubscription } from "../../types/course";

export type CourseSubscriptionContextType = {
  tempSubscriptions: Map<string, TemporarySubscription>;
  setTempSubscriptions: React.Dispatch<
    React.SetStateAction<Map<string, TemporarySubscription>>
  >;
};

export function useCourseSubscriptionContext() {
  return useOutletContext<CourseSubscriptionContextType>();
}
